import ANTDButton from '../../../shared/antd/ANTDButton'
import ANTDInput from '../../../shared/antd/ANTDInput'
import ANTDSelect from '../../../shared/antd/ANTDSelect'
import ANTDSpin from '../../../shared/antd/ANTDSpin'
import PopUpConfirm from '../../../shared/PopUpConfirm'
import { include } from '../../../utils/javascript'
import parentSelector from '../container/parentSelector.container'

const ParentSelector = ({
  showBrand,
  showProduct,
  showUnitType,
  showModel,
  showConfirmation,
  withAdd,
  isAllProductSeries,
}) => {
  const {
    t,
    popup,
    loader,
    isOpen,
    addLoader,
    searchValues,
    tempSelected,
    selectAttributes,
    onScroll,
    onInputSearch,
    handleClosePopup,
    handleAddNewItem,
    onDropdownVisible,
    handleSelectChange,
  } = parentSelector({
    showBrand,
    showProduct,
    showUnitType,
    showModel,
    isAllProductSeries,
  })

  return (
    <div>
      {selectAttributes?.map(
        (
          {
            className,
            hidden,
            options,
            key,
            tabKey,
            searchPlaceholder,
            disableInput,
            disableAdd,
            ...attr
          },
          index,
        ) =>
          !hidden && (
            <div key={index} className={className}>
              <ANTDSelect
                {...attr}
                {...(!withAdd && {
                  showSearch: true,
                  onSearch: search => onInputSearch(search, tabKey),
                })}
                open={isOpen?.[tabKey]}
                style={{ width: '100%' }}
                filterOption={false}
                options={options}
                onChange={(id, option) =>
                  handleSelectChange({ [key]: id, option, showConfirmation })
                }
                onPopupScroll={e => onScroll(e, tabKey)}
                onDropdownVisibleChange={visible =>
                  onDropdownVisible({ [tabKey]: visible })
                }
                dropdownRender={menu => (
                  <>
                    {withAdd && (
                      <div
                        style={{
                          padding: '5px 4px',
                        }}
                        className="d-flex"
                      >
                        <ANTDInput
                          style={{ marginRight: '8px' }}
                          placeholder={searchPlaceholder}
                          value={searchValues?.[tabKey] ?? ''}
                          disabled={disableInput}
                          onChange={e =>
                            onInputSearch(e?.target?.value, tabKey)
                          }
                          onKeyDown={e => e.stopPropagation()}
                        />

                        <ANTDButton
                          type="primary"
                          disabled={
                            !searchValues?.[tabKey]?.trim() ||
                            loader ||
                            include(
                              options?.map(({ label }) => label),
                              searchValues?.[tabKey],
                            ) ||
                            disableAdd
                          }
                          loading={addLoader}
                          onClick={() =>
                            handleAddNewItem({ key, tabKey, showConfirmation })
                          }
                        >{`${t('btn_Add')} +`}</ANTDButton>
                      </div>
                    )}
                    {menu}
                    {loader && (
                      <ANTDSpin size="small" style={{ paddingLeft: 10 }} />
                    )}
                  </>
                )}
              />
            </div>
          ),
      )}
      <PopUpConfirm
        isOpen={popup?.open}
        onCancelModel={handleClosePopup}
        description={popup?.message}
        onAccept={() => {
          handleSelectChange({ showConfirmation: false, ...tempSelected })
          handleClosePopup()
        }}
        onReject={handleClosePopup}
      />
    </div>
  )
}

export default ParentSelector
